import { cx } from '@linaria/core';
import { pm2ConfigStore } from '@pm2/store';
import { PrintRoundedGraphic, PrintWavesGraphic, PrintBubblesGraphic } from '@ui/kit/icons';
import { jsx } from 'react/jsx-runtime';

function ReliefSVG(props) {
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  switch (audience) {
    case "Grade1To3":
      return /*#__PURE__*/jsx(PrintBubblesGraphic, {
        className: cx(props.className, "fill", "bubbles"),
        preserveAspectRatio: "none"
      });
    case "Grade4To6":
      return /*#__PURE__*/jsx(PrintWavesGraphic, {
        className: cx(props.className, "fill", "waves"),
        preserveAspectRatio: "none"
      });
    default:
      {
        return /*#__PURE__*/jsx(PrintRoundedGraphic, {
          className: cx(props.className, "rounded"),
          preserveAspectRatio: "none"
        });
      }
  }
}

export { ReliefSVG };
//# sourceMappingURL=atom.relief-svg.js.map
